import { mdiAlertCircle } from '@mdi/js';
import { SxProps, Typography } from '@mui/material';
import React from 'react';
import Icon from '@mdi/react';
import { labelFontSemiBold, vars } from '../../../../Theme';

const infoBoxSx = {
    mb: 2,
    padding: '12px',
    display: 'flex',
    gap: 1.5,
    border: `1px solid ${vars.brandDarkBlue}`,
    borderRadius: '4px',
};

const textSx = {
    ...labelFontSemiBold,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
};

export default (props: {
    text: string;
    wrapperSx?: SxProps;
    typographySx?: SxProps;
    icon: string;
    color?: (typeof vars)[keyof typeof vars];
    iconSize?: string | number;
    iconWrapperSx?: SxProps;
}) => {
    const {
        text,
        typographySx = {},
        wrapperSx = {},
        iconWrapperSx = {},
        icon = mdiAlertCircle,
        color = vars.brandDarkBlue,
        iconSize = 1,
    } = props;

    return (
        <Typography
            component='span'
            sx={{
                ...infoBoxSx,
                color,
                border: `1px solid ${color}`,
                ...wrapperSx,
            }}
        >
            <Typography sx={iconWrapperSx} component='span'>
                <Icon path={icon} size={iconSize} color={color} />
            </Typography>

            <Typography component='span' sx={{ ...textSx, ...typographySx }}>
                {text}
            </Typography>
        </Typography>
    );
};
